import {useEffect, useState} from 'react';
import { Select } from 'antd';
import {useApi} from "../provider/ApiProvider";
const { Option } = Select;

export default function CustomerSeletor({value, onChange}){


    const {api} = useApi();
    const [options, setOptions] = useState([]);

    useEffect(() =>{
        api.get('/customerRouter/customer/all').then(resp => {
            setOptions(resp.data);
        })
    },[])

    function onChangeSelect(value) {
        let found = options.find(x => x.id === value);
        onChange(value, found);
    }

    return (<div>
        <Select
            showSearch
            placeholder="Müşteri Seç"
            optionFilterProp="children"
            onChange={onChangeSelect}
            value={value}
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {options.length > 0 && options.map((item, idx) => (
                <Option value={item.id}>{item.name}</Option>
            ))}
        </Select>
    </div>)
}
